import { useQuery } from '@tanstack/react-query';

import useAuth from './useAuth';
import useResponseHandler from 'features/SpilKlub/state/useResponseHandler';
import { fetchPools } from 'features/SpilKlub/server/requests';

const useGroupWithPools = ({
    groupId,
    staleTime = 0,
    enabled = true,
    authHandler,
}) => {
    const { userId } = useAuth();

    const { handleResponse } = useResponseHandler({
        requestHandler: fetchPools,
        payload: { groupId },
        authHandler,
    });

    const { status, data, error } = useQuery(
        ['pools', groupId],
        handleResponse,
        { enabled, staleTime }
    );

    return {
        status,
        data,
        error,
        isGroupOwner: data?.group.groupOwnerId === userId,
    };
};

export default useGroupWithPools;
